import Fade from "react-reveal/Fade";
import Reveal from "react-reveal/Reveal";

import { Desktop } from "./Desktop";
import { Small } from "./Small";
import { Medium } from "./Medium";
import { useMedia } from "./media-queries";

export function AssessmentsSection({ amount, onAction }) {
  const size = useMedia();

  let Component = Desktop;
  if (size === "medium") Component = Medium;
  if (size === "small") Component = Small;
  
  return (
    <Reveal>
      <Component
        title={
          <>
            <Fade top cascade>
              <span>{amount?.toLocaleString("en-US")}</span>
            </Fade>
            Assessments completed.
          </>
        }
        description="Assessments description"
        image="img/assessment.png"
        onAction={onAction}
      />
    </Reveal>
  );
}
